import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "subscribe",
  "use": "subscribe-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"subscribe\"><path d=\"M2 11a2 2 0 012-2h40a2 2 0 012 2v26a2 2 0 01-2 2H4a2 2 0 01-2-2V11z\" stroke=\"#474B4F\" stroke-width=\"1.5\" /><path d=\"M3 10l21.069 16.848a.3.3 0 00.378-.003L45.5 9.5M3 38l17-14M45.5 38L28 23.623\" stroke=\"#474B4F\" stroke-width=\"1.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol